import { render, staticRenderFns } from "./FiltersForBlockEditorPanel.vue?vue&type=template&id=7683572f&"
import script from "./FiltersForBlockEditorPanel.vue?vue&type=script&lang=js&"
export * from "./FiltersForBlockEditorPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports